import urls from './urls'
import Service from '@/utils/fetch'

/**
 * 
 */


export function _getPackageList(data) {
    return Service({
        url:urls.getPackageList,
        data
    })
}

export function _getUnitType(data) {
    return Service({
        url:urls.getUnitType,
        data
    })
}

export function _getPmsList(data) {
    return Service({
        url:urls.getPmsList,
        data
    })
}

export function _createEditPms(data) {
    return Service({
        url:urls.createEditPms,
        data
    })
}




// WEBPACK FOOTER //
// ./src/api/Permission/index.js